import { render, staticRenderFns } from "./QuestionGroupCreateModal.vue?vue&type=template&id=4002eb3e&scoped=true&"
import script from "./QuestionGroupCreateModal.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4002eb3e",
  null
  
)

export default component.exports